module.exports = __webpack_public_path__ + "524b22cf8074a7412c69b70baf5a4e2d.jpg";